import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';
import { computed } from '@ember/object';

const STATUSES = {
  UNAVAILABLE: 0,
};

export const FREELANCER_CALENDAR = {
  STATUSES,
};

const FreelancerCalendar = ShModel.extend({
  status: attr('number'),
  startAt: attr('date'),
  endAt: attr('date'),

  profile: belongsTo('profile', { async: false }),

  /**
   * True if we have a start and end date for this preference
   *
   * @return {boolean}
   */
  isTimed: computed('startAt', 'endAt', function() {
    return !!this.get('startAt') && !!this.get('endAt');
  }),

  /**
   * Return true if we have a start and an end date, and the preference and we're before the just the end date.
   *
   * @return {boolean}
   */
  isWithinTimeframe: computed('startAt', 'endAt', function() {
    let startAt = this.get('startAt'),
      endAt = this.get('endAt');

    if (!startAt || !endAt) {
      return false;
    }

    let now = new Date();
    now.setHours(0,0,0,0);
    return now <= endAt;
  }),

  /**
   * Regardless of anything else, return whether this calendar event is expired.
   *
   * @return {boolean}
   */
  isExpired: computed('status', 'isWithinTimeframe', 'isTimed', function() {
    if (this.get('isTimed')) {
      return !this.get('isWithinTimeframe');
    }

    return false;
  }),

  /**
   * True if this status is ON, this will take into account if a preference is timed or not
   *
   * @return {boolean}
   */
  isStatusUnavailable: computed('status', 'isWithinTimeframe', 'isTimed', function() {
    if (this.get('status') === FREELANCER_CALENDAR.STATUSES.UNAVAILABLE && this.get('isTimed')) {
      return this.get('isWithinTimeframe');
    }

    return false;
  }),
});

export default FreelancerCalendar;
